import * as React from 'react';
import type { JSX } from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import { AnyAction, Dispatch } from 'redux';
import { GetUserData } from '../../../business/Profile/ProfileEpics';
import { RootState } from '../../../business/root-store';
import { LegacyMatch, withMatch } from '../../../business/router/with-match';
import { EditProfilePageComponent } from './EditProfilePageComponent';

interface IEditProfilePageContainerReduxMergedProps {
	match: LegacyMatch<{ id?: string }>;
}

interface IEditProfilePageContainerOwnProps {}

interface IEditProfilePageContainerDispatchProps {
	getUserData: (userId: number) => void;
}

interface IEditProfilePageContainerProps
	extends IEditProfilePageContainerOwnProps,
		IEditProfilePageContainerDispatchProps,
		IEditProfilePageContainerReduxMergedProps {}

interface IEditProfilePageComponentState {}

class EditProfilePageContainer extends React.Component<
	IEditProfilePageContainerProps,
	IEditProfilePageComponentState
> {
	constructor(props: IEditProfilePageContainerProps, state: IEditProfilePageComponentState) {
		super(props, state);
		this.state = this.getInitialState();
		const userIdFromUrl = +this.props.match.params.id!;
		this.props.getUserData(userIdFromUrl);
	}

	public render(): JSX.Element {
		return <EditProfilePageComponent />;
	}

	public static mapDispatchToProps = (
		dispatch: Dispatch<AnyAction>
	): IEditProfilePageContainerDispatchProps => {
		return {
			...Redux.bindActionCreators(
				{
					getUserData: GetUserData
				},
				dispatch
			)
		};
	};

	private getInitialState = (): IEditProfilePageComponentState => {
		return {} as IEditProfilePageComponentState;
	};
}
export const EditProfilePage = withMatch(
	connect(
		null,
		EditProfilePageContainer.mapDispatchToProps
	)(EditProfilePageContainer) as unknown as React.ComponentType<{
		match: LegacyMatch<{ id?: string }>;
	}>
);
